import React, { ReactElement, useEffect, useState } from 'react';
import {
  EventName,
  useEventsContext,
} from '../../context/events/EventsContext';
import { useUserAccountStatusQuery } from '../AccountVerification/operation.generated';
import Page from '../Page';
import useAcceptUserTerms from './useAcceptUserTerms';
import UserConsentModal from './UserConsentModalV2';

export interface EthicalPromptProps {
  children: ReactElement;
}

const EthicalPrompt = ({ children }: EthicalPromptProps) => {
  const [eventTracking] = useEventsContext();
  const { data } = useUserAccountStatusQuery();

  const showPrompt = !data?.user.hasAcceptedTerms;
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(
    data?.user.hasAcceptedTerms || false
  );

  const [acceptUserTerms, { loading }] = useAcceptUserTerms({
    onCompleted: completed => {
      if (completed.acceptUserTerms.success) {
        setHasAcceptedTerms(true);
        eventTracking.track({ type: EventName.UserConductPromptAccepted });
      }
    },
  });

  // Track when prompt is shown
  useEffect(() => {
    if (showPrompt && !hasAcceptedTerms) {
      eventTracking.track({ type: EventName.UserConductPromptShown });
    }
  }, [eventTracking, showPrompt, hasAcceptedTerms]);

  // Early return if terms are accepted - must come after all hooks
  if (hasAcceptedTerms) {
    return children;
  }

  return (
    <Page id="ethical-prompt" title="User Conduct">
      <UserConsentModal
        open={showPrompt}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={acceptUserTerms}
        loading={loading}
      />
    </Page>
  );
};

export default EthicalPrompt;
